import { Component, OnInit, OnDestroy, ViewEncapsulation, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../login.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { environment } from '../../environments/environment';
import { FooterService } from '../footer.service';
import * as _html2canvas from "html2canvas";
const html2canvas: any = _html2canvas;


@Component({
  selector: 'app-print-billing',
  templateUrl: './print-billing.component.html',
  styleUrls: ['./print-billing.component.css']
})
export class PrintBillingComponent implements OnInit, OnDestroy {
  chekoutArray: any;
  model: any;
  discount: any = [];
  tot_amt: number;
  Inv_tot: number = 0;
  disAmt: any;
  dataresult: any = [];
  multiple_offer: any = [];
  currentUser: any;
  invoiceTotal: number = 0;
  currDate: string;
  product_multiple_offer: any = [];
  productsTobuy: any = {};
  bill_no: number = 0;
  billed_on: any;
  full_bill: any;
  readcash: number = 0;
  readg_pay: number = 0;
  readcard: number = 0;
  readtips: number = 0;
  readcheque: number = 0;
  readonline_banking: number = 0;
  readsalary: number = 0;
  add_charge: any = [];
  add_charge_value: Number = 0;
  add_charge_value2: Number = 0;
  add_charge_value3: Number = 0;
  add_charge_value4: Number = 0;
  add_charge_value5: Number = 0;

  add_charge_name: string = '';
  add_charge_name2: string = '';
  add_charge_name3: string = '';
  add_charge_name4: string = '';
  add_charge_name5: string = '';
  base64Image: any;
  showLoader: boolean = false;

  gstEnabled: boolean = false;
  cgst: number = 0;
  sgst: number = 0;

  constructor(
    private router: Router,
    private activerouter: ActivatedRoute,
    private loginservice: LoginService,
    private _flashMessagesService: FlashMessagesService,
    private footerService: FooterService

  ) { }

  ngOnInit() {
    this.footerService.hideFooter();
    window.scrollTo(0, 0);
    this.currentUser = JSON.parse(this.loginservice.getLocalSession('currentUser'));
    this.gstEnabled = this.currentUser['gstEnabled'];
    if (this.gstEnabled == true) {
      // this.cgst = 0;
      // this.sgst = 0;
      this.cgst = this.currentUser['cgst'];
      this.sgst = this.currentUser['sgst'];
    } else {
      this.cgst = 0;
      this.sgst = 0;
    }
    this.activerouter.queryParams.subscribe(params => {
      this.model = JSON.parse(params['model']);
      this.tot_amt = JSON.parse(params['tot_amt']);
      this.invoiceTotal = JSON.parse(params['invoiceTotal']);
      this.multiple_offer = JSON.parse(params['multiple_offer']);
      this.chekoutArray = JSON.parse(params['chekoutArray']);
      this.discount = JSON.parse(params['discount']);
      this.product_multiple_offer = JSON.parse(params['product_multiple_offer']);
      this.productsTobuy = JSON.parse(params['productsTobuy']);
      this.bill_no = JSON.parse(params['bill_no']);
      this.add_charge = JSON.parse(params['add_charge']);
      this.billed_on = JSON.parse(params['billed_on']);
      this.model['cash'] = 0;
      this.model['g_pay'] = 0;
      this.model['card'] = 0;
      this.model['cash'] = 0;
      this.model['cheque'] = 0;
      this.model['online_banking'] = 0;
      this.model['salary'] = 0;
      if (this.add_charge.length > 0) {
        this.add_charge_value = this.add_charge[0].add_charge;
        this.add_charge_value2 = this.add_charge[0].add_charge2;
        this.add_charge_value3 = this.add_charge[0].add_charge3;
        this.add_charge_value4 = this.add_charge[0].add_charge4;
        this.add_charge_value5 = this.add_charge[0].add_charge5;

        this.add_charge_name = this.add_charge[0].charge_name;
        this.add_charge_name2 = this.add_charge[0].charge_name2;
        this.add_charge_name3 = this.add_charge[0].charge_name3;
        this.add_charge_name4 = this.add_charge[0].charge_name4;
        this.add_charge_name5 = this.add_charge[0].charge_name5;
      } else {
        this.add_charge_value = 0;
        this.add_charge_value2 = 0;
        this.add_charge_value3 = 0;
        this.add_charge_value4 = 0;
        this.add_charge_value5 = 0;

        this.add_charge_name = '';
        this.add_charge_name2 = '';
        this.add_charge_name3 = '';
        this.add_charge_name4 = '';
        this.add_charge_name5 = '';
      }

      if (params['full_bill'] && JSON.parse(params['full_bill'])) {
        this.full_bill = JSON.parse(params['full_bill']);
      } else {
        this.loginservice.full_bill(this.bill_no, this.currentUser).subscribe(
          data => {
            this.full_bill = data['comp_details']
            this.readcash = data['cash'];
            this.readg_pay = data['g_pay'];
            this.readcard = data['card'];
            this.readtips = data['tips'];
            this.readcheque = data['cheque'];
            this.readonline_banking = data['online_banking'];
            this.readsalary = data['salary'];
            this.model.cash = data['cash'];
            this.model.g_pay = data['g_pay'];
            this.model.card = data['card'];
            this.model.cheque = data['cheque'];
            this.model.online_banking = data['online_banking'];
            this.model.salary = data['salary'];
            this.model.tips = data['tips'];
          }, error => { alert('Network Error getserviceoffered API'); });
      }
      if (this.model['isWhatsApp'] === '1') {
        setTimeout(() => { this.captureAndSend() }, 2000);
      }
    }, error => { alert('Network Error full_bill API'); });

    // Get current date
    var currentDate = new Date();

    // Extract day, month, and year
    var day = currentDate.getDate().toString();
    var month = (currentDate.getMonth() + 1).toString(); // January is 0, so we add 1
    var year = currentDate.getFullYear().toString();

    // Ensure day and month are in two-digit format
    if (day.length < 2) {
      day = '0' + day;
    }
    if (month.length < 2) {
      month = '0' + month;
    }

    // Format the date as "dd-mm-yyyy"
    this.currDate = day + '-' + month + '-' + year;

    this.showLoader = true;
    let newModel = JSON.parse(this.loginservice.getLocalSession('customer_details'));
    if (newModel) {
      this.loginservice.delCustomerCheckout(newModel.id, this.currentUser).subscribe(datal => {
        this.loginservice.delCheckout(newModel['id'], this.currentUser).subscribe(
          datall => {
            this.showLoader = false;
          }, error => { alert('Network Error delCheckout API'); });
      }, error => { alert('Network Error delCustomerCheckout API'); });
      localStorage.removeItem('customer_details');
    }

  }

  captureAndSend() {
    this.showLoader = true;
    const element = document.getElementById('divToPrint');
    if (element) {
      const images = element.getElementsByTagName('img');
      const imagePromises = Array.from(images).map(img => {
        return new Promise((resolve) => {
          if (!img.src || img.src.startsWith('data:')) {
            resolve(img);
            return;
          }

          fetch(img.src)
            .then(response => response.blob())
            .then(blob => {
              const reader = new FileReader();
              reader.onloadend = () => {
                img.src = reader.result as string;
                resolve(img);
              };
              reader.readAsDataURL(blob);
            })
            .catch(() => {
              console.warn('Could not fetch image, using original');
              resolve(img);
            });
        });
      });

      Promise.all(imagePromises).then(() => {
        setTimeout(() => {
          html2canvas(element, {
            scale: 2,
            useCORS: false,
            allowTaint: true,
            backgroundColor: '#ffffff',
            logging: false
          }).then(canvas => {
            this.base64Image = canvas.toDataURL('image/jpeg', 0.95);
            this.loginservice.saveBill(this.base64Image, this.bill_no, this.currentUser).subscribe(
              response => {
                this.showLoader = false;
                if (response['updatedCredit'] && response['updatedCredit'] > 0) {
                  this.currentUser.credits = response['updatedCredit'];
                  this.loginservice.setLocalSession(this.currentUser, 'currentUser');
                }
                if (response['status'] === 'low') {
                  this._flashMessagesService.show(response['msg'], { cssClass: 'alert-success' });
                  alert(response['msg']);
                }
              },
              error => {
                alert('Network Error saveBill API');
                this.showLoader = false;
                console.error('Error saving image', error);
              }
            );
          }).catch(error => {
            alert('Error capturing bill image');
            this.showLoader = false;
            console.error('Error capturing element with html2canvas', error);
          });
        }, 1000);
      });
    } else {
      this.showLoader = false;
      console.error('Element not found');
    }
  }

  paymentMode() {
    let totPay = parseInt(this.model['cash']) + parseInt(this.model['g_pay']) + parseInt(this.model['card']) + parseInt(this.model['tips']) + parseInt(this.model['cheque']) + parseInt(this.model['online_banking']) + parseInt(this.model['salary'])
    if (this.invoiceTotal == totPay) {
      this.loginservice.savepaymentMode(this.model, this.bill_no, this.currentUser)
        .subscribe(
          data => {
            this._flashMessagesService.show('Payment Mode Saved!', { cssClass: 'alert-success' });
          }, error => { alert('Network Error savepaymentMode API'); });
    } else {
      alert('mis match')
    }
  }



  getDisc(sid, bill_no) {
    for (let i = 0; i < this.full_bill.length; i++) {
      let element = this.full_bill[i];
      if (element.bill_no === bill_no && element.service_desc_id === sid) {
        let reAmnt = ((element.discounted_amount / element.amount1) * 100);
        if (reAmnt > 0) {
          return (Math.floor(reAmnt * 10) / 10).toFixed(1) + '%';
          // return reAmnt + '%';
        } else {
          return null;
        }
      }
    }
    return null;  // Default return value if no matching element is found
  }

  getDiscpro(ele, bill_no) {

  }


  getKeyValues(obj: any, anyParam): { key: string, value: any[] }[] {
    return Object.keys(obj).map(key => ({ key, value: obj[key] }));
  }

  convertToWords(number: number): string {
    // Define an array of words for numbers 0 to 19
    const units: string[] = ['Zero', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];

    // Define an array of words for tens multiples
    const tensMultiples: string[] = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

    // Define an array of words for powers of thousand
    const tensPowers: string[] = ['', 'Thousand', 'Million', 'Billion', 'Trillion'];

    // Function to convert numbers less than 1000 to words
    const convertLessThanOneThousand = (num: number): string => {
      if (num === 0) {
        return '';
      }
      let word = '';
      if (num < 20) {
        word = units[num];
      } else if (num < 100) {
        word = tensMultiples[Math.floor(num / 10)] + (num % 10 !== 0 ? ' ' + units[num % 10] : '');
      } else {
        word = units[Math.floor(num / 100)] + ' Hundred ' + convertLessThanOneThousand(num % 100);
      }
      return word.trim();
    };

    // Function to recursively convert large numbers to words
    const convertToWordsHelper = (num: number, power: number): string => {
      if (num === 0) {
        return '';
      }

      let word = convertToWordsHelper(Math.floor(num / 1000), power + 1); // Recursive call for higher powers
      let remainder = convertLessThanOneThousand(num % 1000);

      if (remainder) {
        word += (word ? ' ' : '') + remainder + ' ' + tensPowers[power];
      }

      return word.trim();
    };

    // Function to handle the decimal part
    const handleDecimalPart = (num: number): string => {
      let decimalPart = Math.round((num % 1) * 100); // Get the fractional part as an integer (e.g., 79.2 => 20)
      if (decimalPart > 0) {
        if (decimalPart < 20) {
          return ' point ' + units[decimalPart] + ' paisa'; // Convert to words for numbers below 20
        } else {
          return ' point ' + tensMultiples[Math.floor(decimalPart / 10)] + ' ' + (decimalPart % 10 !== 0 ? units[decimalPart % 10] + ' paisa' : 'paisa');
        }
      }
      return '';
    };

    if (number === 0) {
      return 'Rupees Zero Only';
    }

    // Separate the integer part and decimal part
    let integerPart = Math.floor(number);
    let decimalPart = handleDecimalPart(number);

    // Convert the integer part to words and append the decimal part if it exists
    let words = convertToWordsHelper(integerPart, 0).trim();

    // Return the final output with "Rupees" and "paisa" formatting
    return 'Rupees ' + words + decimalPart;
  }




  // public mprint() {
  //   var printContents = document.getElementById('divToPrint').innerHTML;
  //   var originalContents = document.body.innerHTML;
  //   document.body.innerHTML = printContents;
  //   window.print();
  //   document.body.innerHTML = originalContents;
  // }

  public mprint() {
    // var printContents = document.getElementById('divToPrint').innerHTML;
    // var originalContents = document.body.innerHTML;
    // document.body.innerHTML = printContents;
    window.print();

    // Restore the original content after printing
    // setTimeout(() => {
    //   document.body.innerHTML = originalContents;
    // }, 1000); // Adjust the delay time as needed

    // Navigate to the 'print' route after printing
    // this.navigateToPrintRoute();
  }

  ngOnDestroy() {
    this.footerService.showFooter();
  }

  private navigateToPrintRoute() {
    alert('ssss')
    this.router.navigate(['print'], {
      queryParams: {
        model: JSON.stringify(this.model),
        tot_amt: JSON.stringify(this.tot_amt),
        invoiceTotal: JSON.stringify(this.invoiceTotal),
        multiple_offer: JSON.stringify(this.multiple_offer),
        chekoutArray: JSON.stringify(this.chekoutArray),
        discount: JSON.stringify(this.discount),
      }
    });
  }

  toNum(add_charge_value) {
    return Number(add_charge_value)
  }

  roundGst(value) {
    return Math.round(value);
  }

  getBillLogoPath(): string {
    if (this.currentUser && this.currentUser.billLogo) {
      // If salon has custom bill logo, use upload URL
      return `${environment.uploadUrl}uploads/salon_bill_logos/${this.currentUser.billLogo}`;
    }
    // Default logo
    return '';
  }

  convertTo12Hour(time: string): string {
    if (!time || time === '00:00:00') return '';

    const [hours, minutes, seconds] = time.split(':').map(Number);

    let period = hours >= 12 ? 'PM' : 'AM';
    let hour12 = hours % 12 || 12;

    return `${hour12}:${minutes.toString().padStart(2, '0')} ${period}`;
  }

  getTotalHours(inTime: string, outTime: string): string {
    if (!inTime || !outTime || inTime === '00:00:00' || outTime === '00:00:00') {
      return '';
    }

    const parseTime = (time: string) => {
      const parts = time.split(':').map(Number);
      return {
        h: parts[0] || 0,
        m: parts[1] || 0,
        s: parts[2] || 0   // ✅ FIX (default 0)
      };
    };

    const inT = parseTime(inTime);
    const outT = parseTime(outTime);

    const inDate = new Date(0, 0, 0, inT.h, inT.m, inT.s);
    const outDate = new Date(0, 0, 0, outT.h, outT.m, outT.s);

    let diff = (outDate.getTime() - inDate.getTime()) / 1000;

    // ✅ overnight fix
    if (diff < 0) {
      diff += 24 * 3600;
    }

    const hours = Math.floor(diff / 3600);
    const minutes = Math.floor((diff % 3600) / 60);

    return `${hours}h ${minutes}m`;
  }

}




// WEBPACK FOOTER //
// ./src/app/print-billing/print-billing.component.ts